export default "__VITE_ASSET__a5117fbc__"